const DYNAMIC_COMPONENTS = {
    ApprovalFillingApplicationModal: () => import('@weights/directConnectModals/approval/FillingApplicationModal'),
    ProjectChooseProjectModal: () => import('@weights/directConnectModals/project/ChooseProjectModal'),
    ProjectPerfectInfoModal: () => import('@weights/directConnectModals/project/ProjectPerfectInfoModal'),
    AttendanceAndSalaryModal: () => import('@weights/directConnectModals/project/AttendanceAndSalaryModal')
}

// 备案申请详情
const FILLING_APPLICATION_DETAILS = 'ent_fillings_record_detail'
// 项目列表-选择项目
const CHOOSE_PROJECT = 'project_choose_10'
// 考勤工资直连弹框
const ATTENDANCE_AND_SALARY = 'attendance_salary_information_400'
// 项目列表详情
const PROJECT_LIST_DETAILS = 'project_detail'

const HANDLE_OPEN_MODAL_STRATEGY = {
    // 备案申请详情
    [FILLING_APPLICATION_DETAILS](event, record) {
        this.directConnectModalComponent = 'ApprovalFillingApplicationModal'

        this.changeDirectConnectModalProp(true, {
            record,
            isDetailModal: true
        })
    },
    // 选择项目
    [CHOOSE_PROJECT](event, record) {
        this.directConnectModalComponent = 'ProjectChooseProjectModal'

        this.changeDirectConnectModalProp(true, {
            record
        })
    },
    // 项目列表详情-考勤工资直连弹框
    [ATTENDANCE_AND_SALARY](event, record, params) {
        this.directConnectModalComponent = 'AttendanceAndSalaryModal'

        this.changeDirectConnectModalProp(true, {
            event,
            record,
            params,
            isDetailModal: true
        })
    },
    // 项目列表详情
    [PROJECT_LIST_DETAILS](event, record, params) {
        this.directConnectModalComponent = 'ProjectPerfectInfoModal'

        this.changeDirectConnectModalProp(true, {
            event,
            record,
            params,
            isDetailModal: true
        })
    }
}

export default {
    components: {
        ...DYNAMIC_COMPONENTS
    },
    data() {
        return {
            // 直连弹框组件
            directConnectModalComponent: undefined,
            // 直连弹框组件传参
            directConnectModalProp: {
                visible: false
            }
        }
    },
    methods: {
        // 打开直连弹框组件
        handleOpenDirectConnectModal(event, localData, params) {
            const eventCode = event.eventCode
            HANDLE_OPEN_MODAL_STRATEGY[eventCode].call(this, event, localData, params)
        },
        // 关闭直连弹框组件
        handleCloseDirectConnectModal() {
            this.$set(this.directConnectModalProp, 'visible', false)
        },
        // 更改直连弹框组件传参值
        changeDirectConnectModalProp(visible, extraProp = {}) {
            this.directConnectModalProp = {
                visible,
                ...extraProp
            }
        }
    }
}
